import { render, staticRenderFns } from "./HouseFundPerformanceFee.vue?vue&type=template&id=6dd395aa&"
import script from "./HouseFundPerformanceFee.vue?vue&type=script&lang=js&"
export * from "./HouseFundPerformanceFee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports